// extracted by mini-css-extract-plugin
export default {"nav-logo":"Education_nav-logo__5EvDz","btn":"Education_btn__5PB8n","section":"Education_section__knixc","sectionone":"Education_sectionone__KlJ3-","date":"Education_date__UMFSw"};